//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ActivityPriorityService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[ActivityPriority.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/activity-priority/detail', {'params':params});
	};

	//GeneratorFlag:[ActivityPriority.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/activity-priority/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}